const API_BASE = '/api'
const AUTH_STORAGE_KEY = 'womentech_auth_user'
const TOKEN_STORAGE_KEY = 'qora_auth_token'

function getAuthHeaders() {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY)
  const headers = {}
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

export const authApi = {
  async getCurrentUser() {
    const response = await fetch(`${API_BASE}/auth/me`, {
      credentials: 'include',
      headers: getAuthHeaders(),
    })
    if (!response.ok) {
      localStorage.removeItem(AUTH_STORAGE_KEY)
      localStorage.removeItem(TOKEN_STORAGE_KEY)
      throw new Error('Not authenticated')
    }
    const user = await response.json()
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user))
    return user
  },
  
  async getUser() {
    return this.getCurrentUser()
  },

  async login(email, password, rememberMe = false) {
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password, remember_me: rememberMe }),
    })
    if (!response.ok) {
      let message = 'Login failed'
      try {
        const error = await response.json()
        message = error.detail || message
      } catch {
        if (response.status === 502 || response.status === 503) {
          message = 'Server is starting up, please try again in a moment'
        } else {
          message = `Login failed (${response.status})`
        }
      }
      throw new Error(message)
    }
    const data = await response.json()
    if (data.token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, data.token)
    }
    const user = { id: data.id, email: data.email, name: data.name, role: data.role }
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user))
    return user
  },

  async logout() {
    localStorage.removeItem(AUTH_STORAGE_KEY)
    localStorage.removeItem(TOKEN_STORAGE_KEY)
    const response = await fetch(`${API_BASE}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthHeaders(),
    })
    return response.ok
  },

  clearStoredUser() {
    localStorage.removeItem(AUTH_STORAGE_KEY)
    localStorage.removeItem(TOKEN_STORAGE_KEY)
  },
}
